// extracted by mini-css-extract-plugin
export default {"wrapperClass":"ey9U83ttf8Pc_lL8hS6w"};